export default __webpack_public_path__ + "static/media/Hardware.ca44b17e.png";